import { Component,  OnDestroy } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { LoaderComponent } from "./shared/components/loader/loader.component";
import { RuntimeConfigService } from './core/config/runtime-config.service';
import { TranslateService } from '@ngx-translate/core';
import { IdleTimeOutService } from './core/service/idle-time-out.service';
import { SignalRService } from './core/service/signalr.service';
import { ToastrService } from 'ngx-toastr';
import { filter, Subscription, take } from 'rxjs';
import { NotificationService } from './core/service/notification.service';
import { HistoryStateService } from './core/service/history_state.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnDestroy {
  title: string = '';
  selectedLang = 'en';
  // nosonar: S1444 - These URLs must change dynamically during application routing
  static previousUrl: string = '';
  static currentUrl: string = '';
  private currentRouteUrl: string = '';
  private isBackNavigation = false;
  private notificationSub?: Subscription;
  private readonly displayedNotificationIds = new Set<string>();


constructor(

  private idleService: IdleTimeOutService,
  private router: Router,

  private signalRService: SignalRService,
  private toastr: ToastrService,
  private notificationService: NotificationService,
  private translateService: TranslateService,
  private historyStateService: HistoryStateService,
  private runtimeConfig: RuntimeConfigService
) {
    this.title = this.runtimeConfig.config.projectName;
    // AppComponent.currentUrl = this.router.url;
    // this.currentRouteUrl = this.router.url;

  
    // this.router.events
    //   .pipe(filter(event => event instanceof NavigationStart))
    //   .subscribe((event: NavigationStart) => {
      
    //     if (event.navigationTrigger === 'popstate') {
    //       this.isBackNavigation = true;
    //       console.log('Back navigation detected, preventing...');
          
    //       setTimeout(() => {
           
    //         this.router.navigateByUrl(this.currentRouteUrl, { replaceUrl: true });
    //       }, 0);
           
    //     }
    //   });

  
    // this.router.events
    //   .pipe(filter(event => event instanceof NavigationEnd))
    //   .subscribe((event: NavigationEnd) => {
    //     if (!this.isBackNavigation) {
    //       AppComponent.previousUrl = AppComponent.currentUrl;
    //       AppComponent.currentUrl = event.url;
    //       this.currentRouteUrl = event.url;
    //       console.log('Normal navigation to:', event.url);
    //     }
    //     this.isBackNavigation = false;
    //   });
this.router.events
  .pipe(filter(event => event instanceof NavigationEnd))
  .subscribe(() => {

    const state = history.state;

    // Save only real navigation states
    if (state?.record || state?.isEditing) {
      this.historyStateService.save(state);
    }
  });
}

  ngOnInit(): void {
   
  const authPages = [
    '/agentlogin',
    '/login',
    '/resetpassword',
    '/forgot-password',
    '/changepassword',
    '/agentchangepassword',
    'novibet/transaction-details',
    'novibet/transaction-withdrawal-details',
    'service-location-reports',
    '/404'
  ];
  const notificationExcludedPages = ['novibet/transaction-details/','novibet/transaction-withdrawal-details','service-location-reports','/login','/crm','/404'];


  // Wait until Angular completes the navigation/redirect
  this.router.events
    .pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      take(1)
    ).subscribe((event: NavigationEnd) => {
      const currentPath = event.urlAfterRedirects;
  const isNotificationExcludedPage = notificationExcludedPages.some(page => currentPath.includes(page));

    // if ('Notification' in window) {
    if ('Notification' in window && !isNotificationExcludedPage) {
      if (Notification.permission === 'default') {
       
        Notification.requestPermission();
      } else if (Notification.permission === 'denied') {
       
        //⚠️ Browser notifications are blocked. Please enable them in browser settings.
        this.toastr.warning(
          'Notifications are blocked. To enable: Click the 🔒 lock icon in the address bar → Site settings → Allow Notifications',
          'Notifications Disabled',
          { timeOut: 15000, closeButton: true }
        );
      }
    }
  });

    
    // const authPages = [ '/agentlogin','/login', '/resetpassword', '/forgot-password', '/changepassword', '/agentchangepassword'];
    // const isAuthPage = authPages.some(page => this.router.url.includes(page));
    const currentPath = window.location.pathname;
    const isAuthPage = authPages.some(page => currentPath.includes(page));
    if (!isAuthPage) {
      this.idleService.startWatching();
    }

    this.notificationSub = this.signalRService.notification$.subscribe((data: any) => {
      const activeUrl = this.router.url || window.location.pathname;
      const isAuthNow = authPages.some(page => activeUrl.includes(page));
      const isExcludedNow = notificationExcludedPages.some(page => activeUrl.includes(page));
      if (isAuthNow || isExcludedNow) {
        return;
      }

      this.showBrowserNotification(data.title, data.message, data);
    });
    
    // Discard legacy flags without interrupting an in-flight session restore.
    sessionStorage.removeItem('forceReloadOnce');
  }

  private showBrowserNotification(title: string, message: string, data?: any): void {
    if (!('Notification' in window) || Notification.permission === 'denied') return;

    const notificationId = data?.notificationId == null ? '' : String(data.notificationId);
    if (notificationId && this.displayedNotificationIds.has(notificationId)) return;
    if (notificationId) {
      // Reserve before requesting permission so a replay cannot queue a second alert.
      this.displayedNotificationIds.add(notificationId);
      if (this.displayedNotificationIds.size > 500) {
        this.displayedNotificationIds.delete(this.displayedNotificationIds.values().next().value!);
      }
    }

   
    let translatedMessage = message;
    if (data?.translationKey && data?.params) {
      const translated = this.translateService.instant(data.translationKey, {
        refNo: data.params.refNo,
        fromStatus: data.params.oldStatus,
        toStatus: data.params.newStatus
      });
      
      if (translated && !translated.includes('NOTIFICATION.')) {
        translatedMessage = translated;
      }
    }

    const notificationOptions: NotificationOptions = {
      body: translatedMessage,
      icon: 'favicon.ico',
      data: data,
      ...(notificationId ? { tag: "remittance-notification:" + notificationId } : {})
    };

    if (Notification.permission === 'granted') {
      const notification = new Notification(title, notificationOptions);
      this.setupNotificationClickHandler(notification, data);
    } else {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          const notification = new Notification(title, notificationOptions);
          this.setupNotificationClickHandler(notification, data);
        } else if (notificationId) {
          this.displayedNotificationIds.delete(notificationId);
        }
      }).catch(() => {
        if (notificationId) this.displayedNotificationIds.delete(notificationId);
      });
    }
  }

  private setupNotificationClickHandler(notification: Notification, data?: any): void {
    notification.onclick = () => {
     
      window.focus();
      notification.close();
      

      if (data?.notificationId) {
        this.notificationService.markAsRead(data.notificationId).subscribe({
          next: () => {
          
            this.notificationService.triggerRefresh();
          },
          error: (err) => {}
        });
      }
      
     
      if (data?.transactionId) {
        sessionStorage.setItem('isCodeTransacted', 'true');
        this.router.navigate(
          ['agent/transaction-center-details', data.transactionId],
          {
            queryParams: {
              type: data.type || data.transactionType || '',
              from: 'TransactionCenter',
              refNo: data.tranRefNo || ''
            }
          }
        );
      }
    };
  }

  ngOnDestroy(): void {
    this.notificationSub?.unsubscribe();
    this.signalRService.stopConnection();
  }
}
